<section *ngIf="!loading">
  <h2 id="title" class="subheading-01-bold">
    Se procederá a dar de alta una oficina con los siguientes datos
  </h2>

  <p>Fecha de alta: {{ value.hireDate }}</p>
  <p>Nombre de oficina: {{ value.nameAgency }}</p>
  <p>Region: {{ selectedRegion.region }}</p>
  <p>Sub-region: {{ selectedSubregion.region }}</p>
  <p>MLS_ID: {{ value.integratorOfficeId }}</p>
  <p>_Office: {{ value.redRemax }}</p>
  <br />
  <p>Nombre y Apellido: {{ value.nameBroker }} {{ value.lastNameBroker }}</p>
  <p>User: {{ value.user }}</p>
  <p>Email: {{ value.email }}</p>
  <br />
  <p>¿Desea continuar?</p>
</section>
